import { createFileRoute, FileRoutesByPath, useRouter } from "@tanstack/react-router";
import { RouteComponent } from "@tanstack/react-router";
import { PermissionEnum } from "types/enums";

export enum RouteType {
    Tenant = "tenant",
    Account = "account",
}

export type FlatRoute = ReturnType<typeof useRouter>["flatRoutes"][number];

export type PaldockRoute = Omit<FlatRoute, "options"> & {
    options: Omit<FlatRoute["options"], "staticData"> & { staticData: RequiredStaticData };
};

export interface RequiredStaticData {
    type: RouteType;
    permissions: PermissionEnum[];
    redirectPermissions?: PermissionEnum[];
    showInSideMenu: boolean;
    sideMenuParent?: FlatRoute | "lazy";
    label: string;
    icon?: React.ReactNode | null;
    sort?: number;
    sideMenuGroup?: number;
    redirects?: FlatRoute[];
    defaultRedirect?: FlatRoute;
    showBreadcrumbsBar?: boolean;
    isPublic?: boolean;
}

export type RouteStaticData = Omit<RequiredStaticData, "type"> & Record<string, unknown>;

export function createPaldockFileRoute<TPath extends keyof FileRoutesByPath>(
    path: TPath,
    type: RouteType
) {
    return <TLoaderData = unknown>(options: {
        staticData: RouteStaticData;
        loader?: (ctx: any) => TLoaderData;
        component?: RouteComponent;
    }) => {
        const paldockLoader = (ctx: any) => {
            return options.loader ? options.loader(ctx) : undefined;
        };

        return createFileRoute(path)({
            ...options,
            staticData: Object.assign(options.staticData, { type }),
            loader: paldockLoader,
        });
    };
}
